import { render, staticRenderFns } from "./MessengerServiceList.vue?vue&type=template&id=61a47208&"
import script from "./MessengerServiceList.vue?vue&type=script&lang=js&"
export * from "./MessengerServiceList.vue?vue&type=script&lang=js&"
import style0 from "./MessengerServiceList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports